import permissionsList from './PermissionsList'

const formatPermissions = arr => arr.map(perm => perm.name)

const can = permissions => string => {
    if(permissions.includes('Dios')) return true
    if(permissions.includes(permissionsList[string])) return true
    console.log(`missing permission ${permissionsList[string]}`)
    return false
}

export { formatPermissions, can }
